export const getContractData = async (oem_id, access_token) => {
  const response = await fetch(`${process.env.REACT_APP_CONTRACT_SERVICE_URL}/contractsdata?oem_id=${oem_id}`, {
    headers: {
      Authorization: `auth_token ${access_token}`,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  if (! response.ok) throw response;
  const jsonResponse = await response.json();
  return jsonResponse;
};
